import * as React from "react";
import * as ReactDOM from 'react-dom';

import "./overlay.css";
import "./input.css";

interface InputProps {
    id: string,
    beginuur: string,
    einduur: string
}

interface myState {
    icon: string,
    classes: string,
    active: boolean,
    beginuur?: string,
    einduur?: string
}

const hours = ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00',
    '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00',
    '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00',
    '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00',
    '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00'
];

export class Input extends React.Component<InputProps, myState> {
    constructor(props: any) {
        super(props);
        this.state = {
            icon: 'fa fa-clock-o',
            classes: 'button icon clock',
            active: false,
            beginuur: this.props.beginuur,
            einduur: this.props.einduur
        };
        console.log(this.state);
    }

    onFocus() {
        this.setState(
            {
                icon: 'fa fa-times',
                classes: 'button icon active',
                active: true
            }
        );
    }

    onBlur() {
        this.setState(
            {
                icon: 'fa fa-clock-o',
                classes: 'button icon',
                active: false
            }
        );
    }

    setFocus() {
        if (!this.state.active) {
            this.onFocus();
            ReactDOM.findDOMNode<HTMLInputElement>(this.refs['tussen']).focus();
        }
        else {
            this.onBlur();
        }
    }

    kiezen() {
        this.setState(
            {
                icon: 'fa fa-clock-o',
                classes: 'button icon',
                active: false,
                beginuur: ReactDOM.findDOMNode<HTMLInputElement>(this.refs['van']).value,
                einduur: ReactDOM.findDOMNode<HTMLInputElement>(this.refs['tot']).value
            }
        );
    }

    setBegin() {
        this.setState(
            {
                icon: 'fa fa-times',
                classes: 'button icon active',
                active: true,
                beginuur: ReactDOM.findDOMNode<HTMLInputElement>(this.refs['van']).value,
            }
        );
    }

    setEinde() {
        this.setState(
            {
                icon: 'fa fa-times',
                classes: 'button icon active',
                active: true,
                einduur: ReactDOM.findDOMNode<HTMLInputElement>(this.refs['tot']).value,
            }
        );
    }

    render() {
        var keuze = this.state.beginuur ? 'tussen ' + this.state.beginuur + ' ' : '';
        var keuze = keuze + (this.state.einduur ? 'en ' + this.state.einduur : '');
        return (
            <div className="container">
                <input type="hidden" value={this.state.beginuur} name={this.props.id + "_begin"} id={this.props.id + "_begin"}/>
                <input type="hidden" value={this.state.einduur} name={this.props.id + "_eind"} id={this.props.id + "_eind"}/>
                <div className="inputContainer">
                    <input ref="tussen" placeholder={this.props.id} className="form-control field"
                           onFocus={this.onFocus.bind(this)} value={keuze} readOnly/>
                    <span className={this.state.classes} onClick={this.setFocus.bind(this)}>
                        <i className="fa fa-clock-o"></i>
                        <i className="fa fa-times"></i>
                    </span>
                </div>
                <div className={"timeslot-wrapper " + (this.state.active ? 'show' : 'hidden')}>
                    <div className="timepicker-field">
                        <div className="field-prefix-wrapper">
                            <select ref="van" defaultValue={this.state.beginuur} className="form-control field select" onChange={this.setBegin.bind(this)}>
                                <option key="" value="" />
                                {
                                    hours.map((hour, i) => {
                                        if ((hours.indexOf(this.state.einduur) == -1) || (hours.indexOf(this.state.einduur) > i))
                                            return <option key={i} value={hour.toString()}>{hour}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="timepicker-field">
                        <select ref="tot" defaultValue={this.state.einduur} className="form-control field select" onChange={this.setEinde.bind(this)}>
                            <option key="" value="" />
                            {
                                hours.map((hour, i) => {
                                    if ((hours.indexOf(this.state.beginuur) == -1) || (hours.indexOf(this.state.beginuur) < i))
                                        return <option key={i} value={hour.toString()}>{hour}</option>
                                })
                            }
                        </select>
                    </div>
                    <span className="btn btn-primary" onClick={this.kiezen.bind(this)}>Kiezen</span>
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./apps/site2/components/aStadBetweenTimes/components/Input.tsx